import { useState } from 'react';
import { ButtonGroup } from '@mui/material';
import { Add } from '@mui/icons-material';
import { Button, Page, PageTitleWithButton } from '../../../../components';
import { TodosList } from './TodosList';

/**
 * @deprecated
 * @returns
 */
export const TodosPage = () => {
  const [isTodoModalOpen, showTodoModal] = useState(false);
  return (
    <Page title="Punchlist To-Dos">
      <PageTitleWithButton
        pageTitleProps={{
          marginBottom: false,
          title: 'Punchlist To-Dos',
          subTitle: 'To-do items across all projects'
        }}
        button={
          <ButtonGroup
            sx={{
              width: {
                xs: '100%',
                sm: 'auto'
              }
            }}
          >
            <Button
              id="create-punchlist"
              asLink
              to="/production/punchlists/create-punchlist"
              startIcon={<Add />}
              color="primary"
              variant="contained"
              sx={{
                width: {
                  xs: '50%',
                  sm: 'auto'
                }
              }}
            >
              Create Punchlist
            </Button>
            <Button
              id="add-todo"
              onClick={() => {
                showTodoModal(true);
              }}
              variant="contained"
              color="primary"
              startIcon={<Add />}
              sx={{
                width: {
                  xs: '50%',
                  sm: 'auto'
                }
              }}
            >
              Add Todo
            </Button>
          </ButtonGroup>
        }
      />
      <TodosList isTodoModalOpen={isTodoModalOpen} showTodoModal={showTodoModal} excludeEmptyForVendors={false} />
    </Page>
  );
};
